import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export type TabValue = string | number;

export interface TabItem {
  value: TabValue;
  label: string;
  icon?: string;
  disabled?: boolean;
  dataCy?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LlTabs',
  props: {
    modelValue: {},
    items: {},
    ariaLabel: { default: undefined },
    density: { default: 'compact' }
  },
  emits: ["update:modelValue", "select"],
  setup(__props: any, { emit: __emit }) {

/**
 * A row of tabs: the house "current page" treatment for Vuetify tabs. The selected tab
 * gets a primary slider, an 8% primary tint and medium weight (the tint is on
 * `.ll-tabs` in style.css), and its label stays in the normal text colour.
 *
 * There is deliberately no `color` prop: Vuetify paints the selected label in `color`,
 * which is the green-text active state this replaced. Tabs come from `items` so every
 * tab gets the same treatment; a label that needs markup (a count, say) uses the
 * `label` slot. Hide a tab by leaving it out of `items`.
 *
 * `select` fires on every click, including on the current tab. Tabs that navigate need
 * it: re-clicking the current tab can still mean "back to this tab's top level".
 */


const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createBlock(_component_v_tabs, {
    "model-value": __props.modelValue,
    density: __props.density,
    "aria-label": __props.ariaLabel,
    "slider-color": "primary",
    class: "ll-tabs",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event as TabValue)))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createBlock(_component_v_tab, {
          key: String(item.value),
          value: item.value,
          "prepend-icon": item.icon,
          disabled: item.disabled === true,
          "data-cy": item.dataCy,
          onClick: ($event: any) => (emit('select', item.value))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "label", { item: item }, () => [
              _createTextVNode(_toDisplayString(item.label), 1)
            ])
          ]),
          _: 2
        }, 1032, ["value", "prepend-icon", "disabled", "data-cy", "onClick"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["model-value", "density", "aria-label"]))
}
}

})